export interface ConsultantConfig {
    readonly companyName?: string;
    readonly consultantName?: string;
    readonly consultantTitle?: string;
    readonly consultantPhoto?: string;
    readonly consultantAvatarUrl?: string;
    readonly companyLogo?: string;
    readonly companyLogoUrl?: string;
    readonly greeting?: string;
    readonly responsePromise?: string;
    readonly ctaText?: string;
    readonly secondaryCtaText?: string;
    readonly successMessage?: string;
    readonly reviewEnabled?: boolean;
    readonly trustBadges?: string[];
    readonly consultantPhone?: string;
}

export const DEFAULT_CONSULTANT_CONFIG: ConsultantConfig = {
    companyName: 'Floori',
    consultantName: 'Floori Design Consultant',
    consultantTitle: 'Design Expert',
    consultantPhoto: 'assets/images/floori-icon.png',
    greeting: "Hi! I can help prepare a personalised estimate for your project.",
    responsePromise: 'Usually responds within 1 business day',
    ctaText: 'Get Free Estimate',
    secondaryCtaText: 'Find a Store',
    successMessage: "Your request has been sent. Your local flooring consultant will review your selection and contact you shortly.",
    reviewEnabled: true,
    trustBadges: ['Free Consultation', 'No Obligation Estimate', 'Private & Secure'],
    consultantPhone: '',
};
